import { FeatureCode } from "@wallet-manager/node-types";
import { useChains } from "../../../components/FetchConfig";
import { usePermission, useTranslation } from "../../../hooks";
import ActiveTabPicker, { TabInfo } from "./components/ActiveTabPicker";
import Filters from "./components/Filters";
import Content from "./Content";
import { useCreateSwapRequestContext } from "./context";
import { TabTypes } from "./types";
import { useEffect } from "react";

const CreateSwapRequestPage = () => {
  const {
    filterFields,
    setFilterFields,
    activeTabId,
    setActiveTabId,
    resetQuoteDetails,
    resetContent,
  } = useCreateSwapRequestContext();

  const { t } = useTranslation("createSwapRequest");
  const { selectChainByPieces } = useChains();
  const { hasPermission } = usePermission();

  const TABS_INFO = [
    {
      id: TabTypes.EXACT_PAY,
      name: t("exactPay"),
      permission: FeatureCode.FeaturesAssetManagement.Swap.exactPay,
    },
    {
      id: TabTypes.EXACT_GET,
      name: t("exactGet"),
      permission: FeatureCode.FeaturesAssetManagement.Swap.exactGet,
    },
  ];

  const handleTabChange = (tabId: string) => {
    setActiveTabId(tabId as TabTypes);
    if (activeTabId !== tabId) {
      resetQuoteDetails();
      resetContent();
    }
  };

  const withTabsInfoConfig = (
    tabsInfo: (TabInfo & { permission: string })[]
  ): TabInfo[] => {
    // permission check
    const tabsInfoWithPermission = tabsInfo.filter((item) =>
      hasPermission(item.permission)
    );

    return tabsInfoWithPermission;
  };

  const tabsInfo = withTabsInfoConfig(TABS_INFO);
  const onlyHaveOneTab = tabsInfo.length === 1;
  const currentActiveTabId = onlyHaveOneTab ? tabsInfo[0]?.id : activeTabId;

  useEffect(() => {
    setActiveTabId(currentActiveTabId as TabTypes);
  }, [activeTabId, tabsInfo]);

  return (
    <div className="wrapper">
      <div className="filters-wrapper">
        <Filters
          fields={filterFields}
          setFields={setFilterFields}
          onlyHaveOneTab={onlyHaveOneTab}
        />
      </div>

      <div className="tab-picker">
        <ActiveTabPicker
          tabsInfo={tabsInfo}
          activeTabId={currentActiveTabId}
          onClickTab={handleTabChange}
        />
      </div>

      <div className="content-wrapper">
        <Content />
      </div>
    </div>
  );
};

export default CreateSwapRequestPage;
